/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { ReactElement, useContext, useEffect, useState } from 'react'

import { Button, Cascader, Col, Form, PageHeader, Result, Row } from 'antd'
import { CascaderValueType } from 'antd/lib/cascader'
import TextArea from 'antd/lib/input/TextArea'
import { SelectFieldAnt } from 'Components/Form'
import { SelectItemProps } from 'Components/Form/Select'
import TextBox from 'Components/Form/TextBox'
import ID_COMPONENTE from 'config/idComponente'
import buscaAgendamentoMultiplo from 'Helpers/agendamentoMultiplo'
import { STATUS_HORARIOS } from 'Models/docas/IHorario'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import WS_DOCAS from 'Services/WS_DOCAS'

import {
  IAgendaAction,
  IAgendamentoMultiplo,
  IHorario,
} from '../../../Models/docas'
import { DocasContext } from '../Context/context'

interface Iprops {
  horario: IHorario
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

interface CascaderItem {
  value: number | string
  label: string
  disabled?: boolean
  children?: CascaderItem[]
}

interface Justificativa {
  texto: string
}

const ModalAlterarHorario = ({
  horario,
  atualizaAgenda,
}: Iprops): ReactElement => {
  const hookForm = useForm()
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const [result, setResult] = useState<number>(0)
  const [resultError, setResultError] = useState<string>('')
  const [value, setValue] = useState<CascaderValueType | null>(null)
  const [options, setOptions] = useState<CascaderItem[]>()
  const [submiting, setSubmiting] = useState<boolean>(false)
  const [tamanhoJustificativa, setTamanhoJustificativa] = useState<number>(0)
  const [tamanhoMinimoJustificativa] = useState<number>(10)
  const [agendamentoMultiplo, setAgendamentoMultiplo] =
    useState<IAgendamentoMultiplo>()
  const [selectTempoTotal, setSelectTempoTotal] = useState<SelectItemProps[]>(
    [],
  )
  const [tempoTotal, setTempoTotal] = useState<number>(1)

  useEffect(() => {
    const agendamento: IAgendamentoMultiplo | undefined =
      buscaAgendamentoMultiplo(horario, docasContext.agendamentosMultiplos)
    setAgendamentoMultiplo(agendamento)

    if (agendamento && agendamento.horarios.length > 1) {
      const opcoesTempo: SelectItemProps[] = []
      const tamanhoJanela: number =
        docasContext.armazemAtual?.tamanhoJanelaSecundaria ?? 60
      let tempoAtual: number = tamanhoJanela

      for (let i = 0; i < agendamento.horarios.length; i++) {
        if (tempoAtual <= 60) {
          opcoesTempo.push(
            tempoAtual % 60 === 0
              ? { value: tempoAtual.toString(), label: '1 hora' }
              : {
                  value: tempoAtual.toString(),
                  label: tempoAtual + ' minutos',
                },
          )
        } else {
          const horas: number = ~~(tempoAtual / 60) //Divisão inteira
          const minutos: number = tempoAtual % 60
          const opcao: SelectItemProps = {
            value: tempoAtual.toString(),
            label: horas + ' horas',
          }

          if (minutos !== 0) {
            opcao.label += ' e ' + minutos + ' minutos'
          }

          opcoesTempo.push(opcao)
        }

        tempoAtual += tamanhoJanela
      }

      setSelectTempoTotal(opcoesTempo)
    }
  }, [])

  useEffect(() => {
    const optionsAux: CascaderItem[] = []

    docasContext.armazemAtual?.agendamentoDocasJanelas?.map((janela) => {
      const docasAux: CascaderItem[] = []
      docasContext.armazemAtual?.agendamentoDocasDocas?.map((doca) => {
        const horarios = docasContext.horarios?.filter(
          (x) =>
            x.cdAgendamentoDocasJanela === janela.cdAgendamentoDocasJanela &&
            x.cdAgendamendoDocasDocas === doca.cdAgendamentoDocasDocas &&
            moment(x.dtHora) >= moment(),
        )

        const horariosAux: CascaderItem[] = []
        horarios?.map((horario) => {
          horariosAux.push({
            value: horario.cdAgendamentoDocasHorario,
            label: moment(horario.dtHora).format('HH:mm'),
            disabled: horario.horarioStatus !== 0 ? true : false,
          })
        })

        docasAux.push({
          value: doca.cdAgendamentoDocasDocas,
          label: doca.nomeDoca,
          disabled: horariosAux.length > 0 ? false : true,
          children: horariosAux,
        })
      })

      optionsAux.push({
        value: janela.cdAgendamentoDocasJanela,
        label: janela.nomeJanela,
        disabled: docasAux.length > 0 ? false : true,
        children: docasAux,
      })
    })
    setOptions(optionsAux)
  }, [docasContext])

  const onChange = (value: CascaderValueType) => {
    if (value) {
      setValue(value)
    }
  }

  useEffect(() => {
    if (result === 200) {
      atualizaAgenda()
    }
  }, [result])

  const handleSave = async (justificativa: Justificativa) => {
    setSubmiting(true)

    const tamanhoJanela: number =
      docasContext.armazemAtual?.tamanhoJanelaSecundaria ?? 60

    if (value) {
      const result = await WS_DOCAS.agenda.agendaTrocaHorario(
        ID_COMPONENTE.DOCAS,
        [horario.cdAgendamentoDocasHorario],
        [parseInt(value[2].toString())],
        justificativa.texto,
        horario.placa,
        horario.nomeEntidade,
        horario.cdEntidade,
        horario.cdVeiculo,
        agendamentoMultiplo?.horarios ? true : false,
        //agendamentoMultiplo?.horarios ? agendamentoMultiplo.horarios.length : 1,
        tempoTotal / tamanhoJanela >= 1 ? tempoTotal / tamanhoJanela : 1,
        tamanhoJanela,
      )
      if (result.status === 200) {
        // if (agendamentoMultiplo) {
        //   agendamentoMultiplo.horarios = agendamentoMultiplo.horarios.filter(
        //     (f) =>
        //       f.cdAgendamentoDocasHorario !== horario.cdAgendamentoDocasHorario,
        //   )

        //   const novosAgendamentos: IHorario[] = []
        //   const tamanhoJanela: number =
        //     docasContext.armazemAtual?.tamanhoJanelaSecundaria ?? 60
        //   for (let i = tamanhoJanela; i < tempoTotal; i += tamanhoJanela) {
        //     const agendamento: IHorario | undefined =
        //       agendamentoMultiplo.horarios.pop()

        //     if (agendamento) {
        //       novosAgendamentos.push(agendamento)
        //     }
        //   }

        //   if (agendamentoMultiplo.horarios.length > 0) {
        //     const itens: IAgendaAction[] = []

        //     agendamentoMultiplo.horarios.map((item) => {
        //       itens.push({
        //         cdAgendamentoDocasHorario: item.cdAgendamentoDocasHorario,
        //         horarioStatus: STATUS_HORARIOS.CANCELADO,
        //         cdCandidatoAgendamento: item.cdCandidatoAgendamento!,
        //         agendamentoMultiplo: true,
        //         placaVeiculo: item.placa,
        //         transportadora: item.nomeTransportadora,
        //         cdEntidade: item.cdEntidade,
        //         cdVeiculo: item.cdVeiculo,
        //       })
        //     })

        //     await WS_DOCAS.agenda.executaAcao(ID_COMPONENTE.DOCAS, itens)
        //   }

        //   if (novosAgendamentos.length > 0) {
        //     const numDocas =
        //       docasContext.armazemAtual &&
        //       docasContext.armazemAtual.agendamentoDocasDocas
        //         ? docasContext.armazemAtual.agendamentoDocasDocas.length
        //         : 1

        //     let cdHorarioAtual: number =
        //       parseInt(value[2].toString()) + numDocas

        //     for (let i = 0; i < novosAgendamentos.length; i++) {
        //       await WS_DOCAS.agenda.agendaTrocaHorario(
        //         ID_COMPONENTE.DOCAS,
        //         [novosAgendamentos[i].cdAgendamentoDocasHorario],
        //         [cdHorarioAtual],
        //         justificativa.texto,
        //         horario.placa,
        //         horario.nomeEntidade,
        //         horario.cdEntidade,
        //         horario.cdVeiculo,
        //       )

        //       cdHorarioAtual += numDocas
        //     }
        //   }
        // }

        setResult(200)
      } else {
        setResult(400)
        setResultError(result.statusText)
      }
    }
  }

  return (
    <>
      <PageHeader ghost={false} title="Alterar horário">
        <>
          {result === 0 ? (
            <>
              <Form layout="vertical" onFinish={handleSave}>
                <Row>
                  <Col span={24}>
                    Horário atual:{' '}
                    {moment(horario.dtHora).format('DD/MM/YYYY - HH:mm')}
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item name="horario" label="Horário desejado">
                      <Cascader options={options} onChange={onChange} />
                    </Form.Item>
                  </Col>
                </Row>
                {agendamentoMultiplo &&
                agendamentoMultiplo.horarios.length > 1 ? (
                  <Row>
                    <Col span={24}>
                      <SelectFieldAnt
                        methods={hookForm}
                        scope="form-alterar-horario"
                        label="Tempo total"
                        name="tempoTotal"
                        items={selectTempoTotal}
                        onChangeValue={(valor: string) =>
                          setTempoTotal(parseInt(valor))
                        }
                        rules={[
                          { required: true, message: 'Campo obrigatório' },
                        ]}
                      />
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  <Col span={24}>
                    <TextBox
                      name="texto"
                      label="Justificativa"
                      rows={5}
                      minimumLength={10}
                      length={tamanhoJustificativa}
                      setLength={setTamanhoJustificativa}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col span={24}>
                    <Button
                      type="primary"
                      disabled={
                        submiting ||
                        tamanhoJustificativa < tamanhoMinimoJustificativa
                      }
                      htmlType="submit"
                    >
                      Salvar
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          ) : (
            <>
              {result === 200 ? (
                <Result
                  status="success"
                  title="Horário alterado com sucesso!"
                />
              ) : null}

              {result !== 200 ? (
                <Result
                  status="error"
                  title="Não foi possível alterar o horário!"
                  subTitle={resultError}
                />
              ) : null}
            </>
          )}
        </>
      </PageHeader>
    </>
  )
}

export default ModalAlterarHorario
